type ParsedCookies = {
  [key: string]: string | undefined;
};

export function parseCookie(cookieHeader: string): ParsedCookies {
  const parsedCookies: ParsedCookies = {};

  // Split the cookie header string into individual cookie strings
  const cookieStrings = cookieHeader.split("; ");

  for (const cookieString of cookieStrings) {
    // Split the cookie string into key-value pair
    const [key, value] = cookieString.split("=");

    // Decode the key and value, then add them to the parsedCookies object
    parsedCookies[decodeURIComponent(key)] = value !== undefined ? decodeURIComponent(value) : undefined;
  }

  return parsedCookies;
}

export function parseFetchCookie(cookieHeader: string): ParsedCookies {
  const parsedCookies: ParsedCookies = {};

  if (!cookieHeader) return parsedCookies;

  const cookieStrings = cookieHeader.split(/,\s*(?=[A-Za-z0-9_\-.]+=)/);

  for (const cookieString of cookieStrings) {
    const [keyValue] = cookieString.split(";");
    const eqIndex = keyValue.indexOf("=");
    if (eqIndex === -1) continue;

    const key = keyValue.slice(0, eqIndex).trim();
    const value = keyValue.slice(eqIndex + 1).trim();

    parsedCookies[decodeURIComponent(key)] = decodeURIComponent(value);
  }

  return parsedCookies;
}
